// ⚠️ FICHIER GÉNÉRÉ — ne pas éditer ici. Source : shared/ui/ · régénérer avec `bash shared/sync.sh`
'use client';
import React from 'react';

/**
 * LA FRISE D'ÉTAPES — des étapes, PAS des onglets (lot D, 09/10/2026).
 *
 * Trois écrans dessinaient la même frise à la main (conduite à tenir après un
 * rejet, assistant de création d'une carte, avancement d'une action) avec trois
 * dessins voisins. Un seul composant : un rang numéroté par étape, coché quand
 * elle est franchie, en couleur quand elle est courante, relié par un trait qui
 * se colore à mesure. Cliquable seulement si `onChange` est fourni.
 *
 * ⚠️ La frise des NON-CONFORMITÉS (`FriseEtapes` dans NC.tsx) n'est PAS celle-ci :
 * ses étapes SONT des onglets (états = onglets, décision du 03/10/2026). Ici une
 * étape franchie se lit, elle ne se rouvre pas.
 */
export function Frise({ etapes, courante, achevee = false, onChange, label }: {
  etapes: { k: string; label: string }[];
  /** La clé de l'étape en cours. */
  courante: string;
  /** Tout est franchi (clôture) : la dernière étape se coche aussi. */
  achevee?: boolean;
  onChange?: (k: string) => void;
  label?: string;
}) {
  const rang = Math.max(0, etapes.findIndex((e) => e.k === courante));
  return (
    <div style={{ display: 'flex', gap: 0, alignItems: 'center' }} aria-label={label || 'Avancement'}>
      {etapes.map((e, i) => {
        const faite = i < rang || (achevee && i === etapes.length - 1);
        const enCours = i === rang && !achevee;
        const Etiquette = onChange ? 'button' : 'span';
        return (
          <React.Fragment key={e.k}>
            <Etiquette type={onChange ? 'button' : undefined} onClick={onChange ? () => onChange(e.k) : undefined}
              aria-current={enCours ? 'step' : undefined}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 11.5, fontWeight: enCours ? 700 : 500, background: 'none', border: 'none', padding: 0, cursor: onChange ? 'pointer' : 'default', fontFamily: 'inherit',
                color: faite ? 'var(--green-600)' : enCours ? 'var(--color-primary-active)' : 'var(--text-muted)' }}>
              <span aria-hidden style={{ width: 16, height: 16, borderRadius: '50%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, flex: 'none',
                background: faite ? 'var(--green-600)' : enCours ? 'var(--color-primary-active)' : 'var(--surface-sunken)', color: faite || enCours ? '#fff' : 'var(--text-muted)' }}>
                {faite ? '✓' : i + 1}
              </span>
              {e.label}
            </Etiquette>
            {i < etapes.length - 1 && <span aria-hidden style={{ flex: 1, height: 1, background: i < rang ? 'var(--green-600)' : 'var(--border-default)', margin: '0 6px', minWidth: 10 }} />}
          </React.Fragment>
        );
      })}
    </div>
  );
}
